module.exports = __webpack_public_path__ + "img/documents-active.4fd3cdfc.svg";